<template>
  <div class="InternetHospital">
    <div class="page_img">
      <img src="@/assets/img/fill_system.jpg" alt="">
    </div>
    <div class="page_content flex_row content">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="font_shadow page_summary">互联网医院诊疗系统</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/fill_main.png" alt="">
      <div class="main_explain fill_explain">远程医疗协作解决方案旨在解决当前医疗资源不平衡、老百姓看病难等问题，围绕“医”、“教”两个核心需求进行打造，满足远程会诊、
        双向转诊、病例研讨、手术指导、影像诊断/超声指导、远程教学、医教互动等需求，提升院际、医院与内外部之间远程协作效率。</div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">眼健康医疗+智慧物联网</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="text-center sys_back"><img src="@/assets/img/fill_back.png" alt=""></div>
      <div class="sys_main">
        <img class="mx-auto img3" src="@/assets/img/fill_main3.png" alt="">
      </div>
      <div class="sys_main" style="margin-top: 1rem;">
        <img class="mx-auto img3" style="width: 60%" src="@/assets/img/fill_main4.png" alt="">
      </div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">互联网远程诊疗专家会诊处方平台</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_back"><img src="@/assets/img/fill_back.png" alt=""></div>
      <div class="sys_main">
        <img class="mx-auto" src="@/assets/img/fill_main1.png" alt="">
      </div>
      <div class="sys_main">
        <img class="mx-auto" src="@/assets/img/fill_main2.png" alt="">
      </div>
    </div>
    <div class="container_title">
      专家远程会诊
    </div>
    <div class="container flex_row">
      <div class="container_item flex_row" v-for="item in containList">
        <img :src="item.img" alt="">
        <span>{{item.title}}</span>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'InternetHospital',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      containList: []
    }
  },
  created() {
    let containList = [
      {
        img: 'https://ow.visumall.com/public/img/fill_small1.png',
        title: '多方视频会诊'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small2.png',
        title: '手机远程操控'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small3.png',
        title: '眼科检查设备'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small4.png',
        title: '数据自动集成'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small5.png',
        title: '医患同屏诊疗'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small6.png',
        title: '实景现场同步'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small7.png',
        title: '实时病历调取'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small8.png',
        title: 'AI辅助诊断'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small9.png',
        title: '在线专家处方'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small10.png',
        title: '技能绩效管理'
      },

    ];
    this.containList = containList;
  },
}
</script>

<style scoped lang="scss">
.InternetHospital {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    width: 100%;
    margin-bottom: 1rem;
    img {
      width: 50%;
    }
    .fill_explain {
      margin-top: 1rem;
      font-weight: 500;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.19rem;
    }
  }
  .system {
    margin-bottom: 1rem;
    .system_title {
      margin-bottom: 0.5rem;
      .sys_summary {
        font-size: 0.3rem;
        text-align: center;
        font-weight: bold;
      }
    }
    .sys_back {
      position: relative;
      width: 100%;
      opacity: 0.15;
      img {
        position: absolute;
        width: 100%;
        left: 50%;
        transform: translate(-50%,-5%);
        z-index: -1;
      }
    }
    .sys_main {
      img {
        width: 55%;
      }
      .img3 {
        width: 75%;
      }
    }
  }
  .container_title {
    margin-bottom: 0.32rem;
    font-size: 0.25rem;
    color: #005AFF;
    text-align: center;
  }
  .container {
    flex-wrap: wrap;
    margin-bottom: 1.1rem;
    .container_item {
      width: 20%;
      flex-direction: column;
      margin-bottom: 0.57rem;
      img {
        width: 81%;
      }
      span {
        margin-top: 0.13rem;
        font-size: 0.22rem;
      }
    }
  }
}
</style>
